import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink, BRAND } from "@/data/site";

export default function FloatingWhatsApp() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <a
      href={buildWhatsAppLink(BRAND.whatsappMessage)}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="WhatsApp ile iletişim"
      className={`fixed z-40 bottom-6 right-6 transition-all duration-700 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
      <span className="absolute inset-0 rounded-full bg-[#25D366]/70 animate-pulse-ring [animation-delay:0.6s]" />
      <span className="relative flex items-center gap-3 bg-[#25D366] text-white font-semibold pl-4 pr-5 py-3.5 rounded-full shadow-[0_10px_40px_-10px_rgba(37,211,102,0.7)] hover:scale-105 transition-transform">
        <MessageCircle className="w-5 h-5" />
        <span className="hidden sm:inline text-sm">WhatsApp'tan Yazın</span>
      </span>
    </a>
  );
}
